// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CommentsCounter_wrapper__86xQ5","counter":"CommentsCounter_counter__P9k10"};